import { ReactElement, useMemo } from 'react';

import { Translate, useBoolean } from '@dreryk/react-common';
import { Dropdown } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import { prescriptionVisitsTranslationKeys } from '../../../../translations';
import { PrescriptionVisitRestoreModal } from '../../../actionBar/PrescriptionVisitRestoreModal';

type UsePrescriptionVisitRestoreDropdownItemOptions = {
   appointmentId: number;
};

type UsePrescriptionVisitRestoreDropdownItemOutput = {
   PrescriptionVisitRestoreDropdownItem: () => ReactElement | null;
   prescriptionVisitRestoreModal: ReactElement;
};

export const usePrescriptionVisitRestoreDropdownItem = (
   options: UsePrescriptionVisitRestoreDropdownItemOptions
): UsePrescriptionVisitRestoreDropdownItemOutput => {
   const creatingAppointmentsAvailable = protectFeature('creatingAppointments');
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();

   return useMemo(
      () => ({
         PrescriptionVisitRestoreDropdownItem: () => (
            <Dropdown.Item
               testId={`prescriptionVisitRestore${options.appointmentId}`}
               disabled={!creatingAppointmentsAvailable}
               onClick={(hide) => {
                  openModal();
                  hide();
               }}
            >
               <Dropdown.Item.Tooltip
                  testId={'restore'}
                  content={prescriptionVisitsTranslationKeys.accountPartiallyBlocked}
                  disabled={creatingAppointmentsAvailable}
               >
                  <Translate>{prescriptionVisitsTranslationKeys.restore}</Translate>
               </Dropdown.Item.Tooltip>
            </Dropdown.Item>
         ),
         prescriptionVisitRestoreModal: (
            <>
               {modalOpened ? (
                  <PrescriptionVisitRestoreModal appointmentId={options.appointmentId} onClose={closeModal} />
               ) : null}
            </>
         ),
      }),
      [creatingAppointmentsAvailable, modalOpened, openModal, closeModal, options.appointmentId]
   );
};
